import CircularProgress from '@mui/material/CircularProgress'
import React, { useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { postPropertyPaginatedDr6 } from '../../Api/index'
import codeIcon from '../SearchFilters/images/xmark.svg'
import useFilterStore from '../Store/filterStore'
import useStore from '../Store/Store' // Import the store
import ViewApiCall from '../ViewApiCall'
import Address from './Address' // Import the Address component
import AllFilters from './Filters'
import MostRecentStatus from './MostRecentStatus/index'
import buildQuery from './newQueryBuilder' // Import buildQuery
import PropertyType from './PropertyType/index'
import styles2 from './styles.module.css'
import BaseAlert from '../Snackbar/NewImplementations/BaseAlert/BaseAlert'

const styles = {
  container: { display: 'flex', flexDirection: 'column', marginBottom: '50px' },
  header: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: '10px'
  },
  divStyles: {
    width: '1.5px',
    height: '23.5px',
    backgroundColor: '#ABABAB',
    margin: '0px 12.5px 2.5px 12.5px',
    display: 'block',
    alignSelf: 'end',
    paddingBottom: '5px'
  }
}

export default function SearchFilters () {
  const {
    address,
    propertyType,
    mostRecentStatus,
    page,
    setIsQueryLoading,
    isQueryLoading,
    setPage,
    setQueryStore,
    setDownloadQueryStore,
    queryStore,
    resetStore
  } = useStore()
  const { setDataResults } = useStore()
  const { firstRender, setFirstRender } = useStore()

  const [errorAlert, setErrorAlert] = useState({
    open: false,
    title: '',
    body: '',
    color: undefined,
    actions: []
  })
  const { allFilters, resetFilters } = useFilterStore()
  const [query, setQuery] = useState() // State to store the query string

  const dataType = 'property'

  const handleClearFilters = () => {
    if (queryStore) {
      resetFilters()
      resetStore()
    }
  }

  useEffect(
    () => {
      if (!firstRender) {
        const newQuery = buildQuery(
          propertyType,
          mostRecentStatus,
          allFilters,
          address
        )
        setQuery({ query: newQuery })
        setPage(1)
      } else {
        setFirstRender(false)
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      propertyType,
      mostRecentStatus,
      allFilters,
      address
    ]
  )

  const [searchFilterRequest] = useMutation(
    ({ page, query }) => postPropertyPaginatedDr6(page, query),
    {
      onMutate: () => {
        // This will fire just before the mutation function is fired, so we can set isLoading to true here.
        setIsQueryLoading(true)
      },
      onSuccess: data => {
        if (data?.data?.errors || data.status >= 400) {
          setQueryStore(query)
          const errMsg = data?.data?.errors?.[0] || 'Something went wrong'

          if (errMsg.includes('property:paginate')) {
            setErrorAlert({
              open: true,
              title: 'Feature not enabled',
              body: 'You need to enable "property.paginate" on your account to use this feature. Contact our team to request that this feature be enabled.',
              color: '#000000',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setErrorAlert(e => ({ ...e, open: false }))
                },
                {
                  label: 'Contact support',
                  onClick: () => {
                    window.location.href = 'mailto:support@datafiniti.co'
                    setErrorAlert(e => ({ ...e, open: false }))
                  }
                }
              ]
            })
          } else if (errMsg === 'No results found for provided query.') {
            setErrorAlert({
              open: true,
              title: 'No results found',
              body: 'Try broadening your filters to find matches.',
              color: '#000000',
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setErrorAlert(e => ({ ...e, open: false }))
                }
              ]
            })
          } else {
            setErrorAlert({
              open: true,
              title: 'Search Error',
              body: errMsg,
              actions: [
                {
                  label: 'Ok',
                  onClick: () => setErrorAlert(e => ({ ...e, open: false }))
                }
              ]
            })
          }

          return
        }
        // Success case
        setQueryStore(query)
        setDataResults(data)
        setDownloadQueryStore({ query: '', id: '' })
      },

      onError: error => {},
      onSettled: () => {
        // This fires when onSuccess or onError is done, so we can set isLoading to false here.
        setIsQueryLoading(false)
      }
    }
  )

  useEffect(
    () => {
      if (!firstRender) {
        const searchFilterRequestFunction = () => {
          searchFilterRequest({ page, query })
        }

        if (query) {
          // Ensure query is set before making the request
          searchFilterRequestFunction()
        }
      }
    },
    /* eslint-disable-line react-hooks/exhaustive-deps */ [
      query,
      searchFilterRequest,
      page
    ]
  )

  useEffect(() => {
    return () => setFirstRender(true)
  }, [setFirstRender])

  const isDisabled = !queryStore || isQueryLoading

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span
          style={{ fontSize: '14px', fontWeight: '500', marginBottom: '14px' }}
        >
          Search filters
        </span>
      </div>
      {/* All the other elements */}
      <div style={styles.header}>
        {/* Address */}
        <Address />
        {/* End of Address */}

        {/* Property Type */}
        <PropertyType />
        {/* End Property Type */}

        {/* MostRecentStatus */}
        <MostRecentStatus />

        {/* End MostRecentStatus */}

        {/* AllFilters */}
        {/* <section style={{ display: "flex", flexWrap: "wrap" }}> */}

        <AllFilters />

        <div style={styles.divStyles}></div>
        {/* End AllFilters */}

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            paddingBottom: '5px'
          }}
        >
          <span
            onClick={queryStore === '' ? undefined : handleClearFilters}
            className={styles2.clearFiltersSearch}
            style={{
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              opacity: isDisabled ? 0.5 : 1
            }}
          >
            Clear filters
          </span>
          <img
            onClick={queryStore === '' ? undefined : handleClearFilters}
            src={codeIcon}
            alt='codeIcon'
            style={{
              height: '14px',
              // width: "15px",
              marginBottom: '1.5px',
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              opacity: isDisabled ? 0.5 : 1 // Reduce opacity if disabled
            }}
          />
        </div>

        <div style={styles.divStyles}></div>

        <ViewApiCall dataType={dataType} />

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            marginLeft: '12.5px'
          }}
        >
          {isQueryLoading ? (
            <CircularProgress
              disableShrink
              size={25}
              style={{ color: '#065E88', marginBottom: '5px' }}
            />
          ) : (
            ''
          )}
        </div>
        {/* </section> */}
      </div>
      {/* <SnackbarComponent snackData={snackMessage} /> */}
      <BaseAlert
        open={errorAlert.open}
        title={errorAlert.title}
        body={errorAlert.body}
        color={errorAlert.color}
        style={{ width: '320px' }}
        actions={errorAlert.actions}
        onClose={() => setErrorAlert(e => ({ ...e, open: false }))}
      />
    </div>
  )
}
